import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-password-rules',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './admin-password-rules.component.html',
  styleUrl: './admin-password-rules.component.scss',
})
export class AdminPasswordRulesComponent {
  @Input() password = '';

  get hasLength(): boolean {
    return this.password.length >= 8 && this.password.length <= 30;
  }

  get hasUppercase(): boolean {
    return /[A-Z]/.test(this.password);
  }

  get hasLowercase(): boolean {
    return /[a-z]/.test(this.password);
  }

  get hasNumber(): boolean {
    return /\d/.test(this.password);
  }

  get hasSymbol(): boolean {
    return /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
  }

  get hasNoSpaces(): boolean {
    return this.password.length > 0 && !/\s/.test(this.password);
  }
}
